import React from "react";
import { useForm } from "react-hook-form"; // ✅ 1. Import useForm
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import { submitProjectInquiry } from "../../Backend/website";

const ServiceModal = ({setIsModalOpen}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  // ... inside your component
  const onSubmitInquiry = async (data) => {
    try {
      // Call the backend function we just created
      const result = await submitProjectInquiry(data);

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Inquiry Submitted!",
          text: "We have received your project details and will be in touch shortly.",
          confirmButtonColor: "#0B1C2D",
          customClass: { popup: "rounded-3xl" },
        });
        reset();
        setIsModalOpen(false);
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      console.error("Submission failed:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Something went wrong. Please try again.",
      });
    }
  };
  return (
    <div>
      <div className="p-8 md:p-10 bg-[#F6F8FB]">
        <form className="space-y-6" onSubmit={handleSubmit(onSubmitInquiry)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Full Name */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Full Name *
              </label>
              <input
                {...register("fullName", { required: "Full Name is required" })}
                type="text"
                placeholder="John Doe"
                className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.fullName ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm`}
              />
              {errors.fullName && (
                <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                  {errors.fullName.message}
                </p>
              )}
            </div>

            {/* Company Name (Optional) */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Company / Brand Name
              </label>
              <input
                {...register("companyName")}
                type="text"
                placeholder="e.g. Indiekraft"
                className="w-full px-6 py-4 rounded-2xl bg-white border border-slate-200 focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm"
              />
            </div>

            {/* Email Address */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Email Address *
              </label>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                type="email"
                placeholder="john@company.com"
                className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.email ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm`}
              />
              {errors.email && (
                <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                  {errors.email.message}
                </p>
              )}
            </div>

            {/* Phone Number */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Phone / WhatsApp *
              </label>
              <input
                {...register("phone", { required: "Phone number is required" })}
                type="tel"
                placeholder="+91 98765 43210"
                className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.phone ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm`}
              />
              {errors.phone && (
                <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                  {errors.phone.message}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Primary Service */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Primary Service Needed *
              </label>
              <select
                {...register("service", {
                  required: "Please select a service",
                })}
                defaultValue=""
                className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.service ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm cursor-pointer appearance-none`}
              >
                <option value="" disabled>
                  Select a service...
                </option>
                <option value="ecommerce">E-Commerce Development</option>
                <option value="landing_page">Custom Landing Page</option>
                <option value="ui_ux">UI/UX Redesign</option>
                <option value="api_integration">API & Integrations</option>
                <option value="branding">Logo & Branding Assets</option>
                <option value="marketing">Digital Marketing</option>
                <option value="maintenance">Website Maintenance/Hosting</option>
              </select>
              {errors.service && (
                <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                  {errors.service.message}
                </p>
              )}
            </div>

            {/* Budget */}
            <div>
              <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
                Estimated Budget (INR) *
              </label>
              <select
                {...register("budget", {
                  required: "Please select a budget range",
                })}
                defaultValue=""
                className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.budget ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-bold text-sm text-[#0B1C2D] transition-all shadow-sm cursor-pointer appearance-none`}
              >
                <option value="" disabled>
                  Select a budget...
                </option>
                <option value="<25k">Less than ₹25,000</option>
                <option value="25k-50k">₹25,000 - ₹50,000</option>
                <option value="50k-100k">₹50,000 - ₹1,00,000</option>
                <option value="100k-250k">₹1,00,000 - ₹2,50,000</option>
                <option value=">250k">₹2,50,000+</option>
                <option value="tbd">To be discussed</option>
              </select>
              {errors.budget && (
                <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                  {errors.budget.message}
                </p>
              )}
            </div>
          </div>

          {/* Project Details */}
          <div>
            <label className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest ml-2 mb-2 block">
              Project Details & Goals *
            </label>
            <textarea
              {...register("projectDetails", {
                required: "Please provide some project details",
              })}
              rows="4"
              placeholder="Tell us about your vision, specific features you need, target audience, and any reference websites..."
              className={`w-full px-6 py-4 rounded-2xl bg-white border ${errors.projectDetails ? "border-red-500" : "border-slate-200"} focus:border-[#E63946] focus:ring-4 focus:ring-[#E63946]/10 outline-none font-medium text-sm text-[#0B1C2D] transition-all resize-none shadow-sm`}
            ></textarea>
            {errors.projectDetails && (
              <p className="text-red-500 text-[10px] font-bold mt-1 ml-2">
                {errors.projectDetails.message}
              </p>
            )}
          </div>

          {/* ✅ 5. Handle Loading State on Button */}
          <motion.button
            whileHover={!isSubmitting ? { scale: 1.02 } : {}}
            whileTap={!isSubmitting ? { scale: 0.98 } : {}}
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-5 mt-4 text-white font-black rounded-2xl uppercase tracking-widest text-xs transition-colors shadow-xl flex justify-center items-center gap-2 ${
              isSubmitting
                ? "bg-slate-400 cursor-not-allowed shadow-none"
                : "bg-[#0B1C2D] hover:bg-[#E63946] shadow-[#0B1C2D]/20"
            }`}
          >
            {isSubmitting ? (
              <>Processing Request...</>
            ) : (
              <>
                Submit Project Inquiry{" "}
                <span className="material-symbols-outlined text-sm">send</span>
              </>
            )}
          </motion.button>
        </form>
      </div>
    </div>
  );
};

export default ServiceModal;
